// TPO File Contact fields (LC-670). The legacy LFC_Plugin_TPO_File_Contacts
// plugin used to write these on the loan; LoganConnect now does it after the
// milestone free roles are synced.

const formatContactNumber = (value) => {
	const digits = String(value ?? "").replace(/\D/g, "");

	return digits.length === 10
		? `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`
		: String(value ?? "");
};

export const resolveAeContact = (aeEmailData) => {
	const loanProcessorContact = aeEmailData?.loan_processor_ae_user_contact;

	return loanProcessorContact?.full_name || loanProcessorContact?.email
		? loanProcessorContact
		: aeEmailData?.ae_user_contact;
};

/**
 * Field values for the assigned AE, matching the entityId sent to
 * update_milestone_free_roles so the file contact and the role stay the
 * same person. Returns null when the AE lookup is unavailable, so an empty
 * payload never blanks out values already on the loan.
 */
export const buildTpoFileContactFieldValues = ({
	aeEmailData,
	aeEntityId,
	organizationId,
}) => {
	const aeContact = resolveAeContact(aeEmailData);

	if (!aeContact || !aeEntityId) {
		return null;
	}

	return [
		{ id: "TPO.X31", value: aeEntityId || "" },
		{ id: "TPO.X16", value: organizationId || "" },
		{ id: 1256, value: aeContact?.full_name || "" },
		{ id: 1262, value: formatContactNumber(aeContact?.phone) },
		{ id: 95, value: aeContact?.email || "" },
		{ id: 1263, value: formatContactNumber(aeContact?.fax) },
		{ id: "Lender.CntctTitle", value: aeContact?.job_title || "" },
	];
};
